import { GridLocation } from "src/grid/GridLocation";
import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

export class NewLineInstruction extends Instruction<"new-line"> {
  readonly type = "new-line";

  act(context: ProgramModel) {
    const location = GridLocation.fromGridIndex(
      context.cursorIndex,
      context.gridDimensions
    );
    location.row += 1;
    location.col = 0;

    context.cursorIndex = location.toGridIndex(context.gridDimensions);
    context.flux += 1;

    return { shouldAdvanceCursor: false };
  }
}
